// extracted by mini-css-extract-plugin
export default {"rewards":"rewards_rewards__rSmd0","content":"rewards_content__MNvvU"};